import {put, takeEvery} from "redux-saga/effects";
import {Size} from "../../../Models/Size";
import {localStorage} from "../../../lib/storages/localStorage";
import {sizesGetError, sizesGetSuccess} from "./actions";
import * as TYPES from "./types";

export default function* sizesSagas() {
    yield takeEvery(TYPES.SIZES_GET_REQUEST, sizesGetRequest);
}

function* sizesGetRequest(action) {
    try {
        let items = [];

        if (localStorage.getItem(TYPES.SIZES_GET_REQUEST)) {
            items = localStorage.getItem(TYPES.SIZES_GET_REQUEST);
        } else {
            const response = yield Size.index({
                ...action.payload,
            });

            items = response.data;
            localStorage.setItem(TYPES.SIZES_GET_REQUEST, items);
        }

        const data = {
            items: items,
            pagination: {total: 0, pages: 0},
        };

        yield put(
            sizesGetSuccess({
                data,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(sizesGetError(error));
    }
}
